import { css } from "@emotion/react";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { match } from "ts-pattern";

import { InputImageWithPreview } from "~/components/common/InpuImageWithPreview";
import {
  getIsQuestTaskVerifyApplied,
  useReviewRequest,
} from "~/components/quest/detail/lib";
import {
  Props,
  useCurrentUserQuestProgress,
} from "~/components/quest/page/[id]/lib";
import { getQuestDurationStatus } from "~/domains/quest/lib";
import { useDataUrlFromBlob } from "~/lib/client/images/useDataFromBlob";
import { Sdk } from "~/lib/graphql/client";
import { useAppContext } from "~/pages/_app";

const ImageResponseArea = ({
  quest,
  questTask,
  client,
  setCompleteQuestTask,
}: {
  quest: Props["quest"];
  questTask: Props["quest"]["questTasks"][number];
  client: Sdk;
  setCompleteQuestTask: (questTaskId: number) => void;
}) => {
  const [imageFile, setImageFile] = useState<Blob | null>(null);
  const imageData = useDataUrlFromBlob(imageFile);
  const [fileName, setFileName] = useState<string>("");

  const { currentUser } = useAppContext();
  const { connecting, reviewRequest } = useReviewRequest({
    client,
    questTask,
  });
  const result = useCurrentUserQuestProgress(
    client,
    [quest.id],
    [questTask.id]
  );
  const isQuestTaskVerifyApplied = getIsQuestTaskVerifyApplied(
    result,
    questTask
  );
  const questDurationStatus = getQuestDurationStatus(quest);

  const disabled =
    !imageData ||
    !fileName ||
    connecting ||
    isQuestTaskVerifyApplied ||
    !currentUser ||
    questDurationStatus !== "OPENING";

  const handleOnChangeFileInput = (file: File | Blob | null) => {
    if (file instanceof File) {
      setFileName(file.name);
    }
    setImageFile(file);
  };

  useEffect(() => {
    if (isQuestTaskVerifyApplied) {
      setCompleteQuestTask(questTask.id);
    }
  }, [isQuestTaskVerifyApplied, setCompleteQuestTask, questTask.id]);

  useEffect(() => {
    (async () => {
      await result.refetch();
    })();
  }, [result]);

  if (!result.isFetched) return null;

  return (
    <div>
      <Button
        disabled={disabled}
        onClick={async () => {
          if (!imageData) return;
          if (!fileName) return;
          await reviewRequest(imageData, fileName);
        }}
        variant={"outlined"}
      >
        {match({
          isQuestTaskVerifyApplied,
          connecting,
          disabled,
          login: !!currentUser,
        })
          .with({ isQuestTaskVerifyApplied: true }, () => "回答済み")
          .with({ login: false }, () => "回答する")
          .with({ connecting: true }, () => "送信中")
          .with({ disabled: true }, () => "回答できません")
          .with(
            { isQuestTaskVerifyApplied: false, disabled: false },
            () => "回答する"
          )
          .exhaustive()}
      </Button>
      <div css={inputImageWithPreviewContainerStyle}>
        <InputImageWithPreview
          imageData={imageData}
          onChange={handleOnChangeFileInput}
        />
      </div>
    </div>
  );
};

const inputImageWithPreviewContainerStyle = css`
  margin-top: 0.5rem;
`;

export default ImageResponseArea;
